export default "__VITE_ASSET__CisMyHBb__"